/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_SubtitleInputs */

const es_home_nexy_subtitle = /** @type {(inputs: Home_Nexy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente inteligente que habla el idioma de tus datos. Mientras otras herramientas solo indexan archivos, Nexy comprende contexto, relaciones y significado.`)
};

const en_home_nexy_subtitle = /** @type {(inputs: Home_Nexy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The intelligent assistant that speaks the language of your data. While other tools only index files, Nexy understands context, relationships, and meaning.`)
};

/**
* | output |
* | --- |
* | "The intelligent assistant that speaks the language of your data. While other tools only index files, Nexy understands context, relationships, and meaning." |
*
* @param {Home_Nexy_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_subtitle = /** @type {((inputs?: Home_Nexy_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_subtitle(inputs)
	return en_home_nexy_subtitle(inputs)
});
export { home_nexy_subtitle as "home.nexy.subtitle" }